"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useTransition } from "react";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { submitClaimRequest } from "@/lib/actions/claim-actions";
interface ClaimFormProps {
  authorSlug: string;
  displayName: string;
}
export function ClaimForm(t0) {
  const $ = _c(44);
  const {
    authorSlug,
    displayName
  } = t0;
  const [email, setEmail] = useState("");
  const [sourceUrl, setSourceUrl] = useState("");
  const [notes, setNotes] = useState("");
  const [error, setError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [pending, startTransition] = useTransition();
  if (submitted) {
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CheckCircle2 className="mx-auto mb-3 size-10 text-emerald-500" />;
      t2 = <h3 className="text-lg font-semibold text-foreground">Claim submitted</h3>;
      $[0] = t1;
      $[1] = t2;
    } else {
      t1 = $[0];
      t2 = $[1];
    }
    let t3;
    if ($[2] !== email) {
      t3 = <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-6 text-center">{t1}{t2}<p className="mt-2 text-sm text-muted-foreground">We'll review your request and reach out at{" "}<strong className="text-foreground">{email}</strong> within a few business days. Once approved, you'll get a one-time takeover link and full control of your profile, stories, and earnings.</p></div>;
      $[2] = email;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t1;
  if ($[4] !== authorSlug || $[5] !== email || $[6] !== notes || $[7] !== sourceUrl) {
    t1 = e => {
      e.preventDefault();
      setError(null);
      startTransition(async () => {
        const result = await submitClaimRequest({
          authorSlug,
          claimantEmail: email,
          sourceUrl,
          notes
        });
        if ("error" in result) {
          setError(result.error);
          return;
        }
        setSubmitted(true);
      });
    };
    $[4] = authorSlug;
    $[5] = email;
    $[6] = notes;
    $[7] = sourceUrl;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Label htmlFor="claim-email">Your email</Label>;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_0 => setEmail(e_0.target.value);
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== email || $[12] !== pending) {
    t4 = <Input id="claim-email" type="email" required={true} placeholder="you@example.com" value={email} onChange={t3} disabled={pending} />;
    $[11] = email;
    $[12] = pending;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="text-xs text-muted-foreground">We'll send a one-time takeover link here once your claim is approved.</p>;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4) {
    t6 = <div className="space-y-2">{t2}{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== displayName) {
    t7 = <Label htmlFor="claim-source">Where you publish ({displayName}'s original profile)</Label>;
    $[17] = displayName;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_1 => setSourceUrl(e_1.target.value);
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== pending || $[21] !== sourceUrl) {
    t9 = <Input id="claim-source" type="url" required={true} placeholder="https://www.royalroad.com/profile/123456" value={sourceUrl} onChange={t8} disabled={pending} />;
    $[20] = pending;
    $[21] = sourceUrl;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="text-xs text-muted-foreground">Royal Road, Wattpad, Substack, your own site — any URL that proves you're the author.</p>;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t7 || $[25] !== t9) {
    t11 = <div className="space-y-2">{t7}{t9}{t10}</div>;
    $[24] = t7;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Label htmlFor="claim-notes">Anything else we should know? (optional)</Label>;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_2 => setNotes(e_2.target.value);
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== notes || $[30] !== pending) {
    t14 = <div className="space-y-2">{t12}<Textarea id="claim-notes" rows={4} maxLength={2000} placeholder="e.g. takedown request instead, or anything that helps us verify." value={notes} onChange={t13} disabled={pending} /></div>;
    $[29] = notes;
    $[30] = pending;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== error) {
    t15 = error && <p className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</p>;
    $[32] = error;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = pending ? "Submitting\u2026" : "Submit claim request";
  let t17;
  if ($[34] !== pending || $[35] !== t16) {
    t17 = <Button type="submit" disabled={pending} className="w-full">{t16}</Button>;
    $[34] = pending;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t1 || $[38] !== t11 || $[39] !== t14 || $[40] !== t15 || $[41] !== t17 || $[42] !== t6) {
    t18 = <form className="space-y-4" onSubmit={t1}>{t6}{t11}{t14}{t15}{t17}</form>;
    $[37] = t1;
    $[38] = t11;
    $[39] = t14;
    $[40] = t15;
    $[41] = t17;
    $[42] = t6;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}